module.exports = __webpack_public_path__ + "img/frame.d57ba25a.png";